exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pricing-table{margin-bottom:0}.pricing-table tbody tr td{border:0}.pricing-table .features{list-style:none;margin:0;padding:0}.pricing-table .table-spacer{padding:7px 5px}.resume-alert{margin-bottom:0}.coupon-alert,.plan-and-pricing-panel .cancel-btn{margin-top:20px}.coupon-alert{margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-14ae874e","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/js/components/PlanAndPricing.vue
// module id = 12
// module chunks = 0